module.exports = __webpack_public_path__ + "static/media/PEP-Ausweis_Banner.58c864d6.jpg";